import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Box } from '../../units/Box/Box';
import ModalForm from './ModalForm';

import FormsSelectors from '../../../store/forms/utils/formsSelectors';

class Forms extends Component {
  static propTypes = {
    forms: PropTypes.array.isRequired
  };

  render() {
    return (
      <Box>
        {this.props.forms.map(form => (
          <ModalForm key={form.formId} form={form} />
        ))}
      </Box>
    );
  }
}
export default connect(state => {
  return {
    forms: FormsSelectors.getModalForms(state)
  };
})(Forms);



// WEBPACK FOOTER //
// ./src/components/containers/Forms/Forms.js